export default {
  buttons: {
    sign_in: 'Sign in',
    sign_up: 'Sign up',
    logout: 'Log out',
  },
  logout_confirm: {
    title: 'Log out?',
    description: 'Are you sure you want to log out?',
    cancel: 'Cancel',
    confirm: 'Log out',
  },
};
